// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT } from './actions';

export const initialState = {
    token: '',
    refresh: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    grupo: null
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user, token, grupo, data, refresh } = action.payload;
            return {
                ...state,
                isLoggedIn,
                isInitialized: true,
                token,
                user, 
                grupo,
                data,
                refresh
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                isInitialized: false,
                token: '',
                refresh: '',
                user: null,
                grupo: null,
                data: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
